// do not change values of the constants (video object proxy to player widget)
export const LIKES = 'LIKE';
export const SHARES = 'SHARE';
export const VIEWS = 'VIEW';

export const ALL_SOCIAL_TYPES = [VIEWS, LIKES, SHARES];

// important: it is mapping between config.json and data in video
export const VIDEO_ENGAGEMENT_SOCIAL_TYPE = {
  VIEWS,
  LIKES,
  SHARES,
} as const;
